// src/components/PixelPageView.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PixelPageView() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);

  return null;
}
